import React from "react";
import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";

const StyledFooter = styled.footer`
  display: flex;
  justify-content: space-between; // Aligns children to the edges
  align-items: center; // Centers items vertically

  width: 100%;
  background-color: #392ab6; // Choose a background color for your footer
  color: #ffffff; // And a text color
  padding: 0px 5px; // Add some padding for aesthetics

  @media (max-width: 600px) {
    padding: 10px; // Smaller padding for smaller screens
  }
`;

const StyledLink = styled.a`
  color: #ffffff;
  text-decoration: none;
  & :hover, & :visited: {
    color: #ffffff;
  }
`;
export default function Footer() {
  const year = new Date().getFullYear();

  const handlePagePopup = (e) => {
    e.preventDefault();
    window.open(
      "https://www.avalonhcs.com/privacy-policy/",
      "Privacy Policy",
      "width=600,height=400"
    );
  };

  return (
    <StyledFooter>
      <Typography component="div" variant="bodytext">
        © {`${year}`} Avalon Healthcare Solutions | Notice of
        <Tooltip
          id="privacyLinkID"
          title="https://www.avalonhcs.com/privacy-policy/"
        >
          <StyledLink onClick={handlePagePopup} target="_blank">
            {" "}
            Privacy Practices
          </StyledLink>
        </Tooltip>
      </Typography>
    </StyledFooter>
  );
}
